import styled from 'styled-components';
import { useCart } from '../../contexts/CartContext';
import { ReactComponent as CartIcon } from '../../../assets/cart-icon.svg';

const CartButtonContainer = styled.button`
  font-family: ${props => props.theme.typography.button.fontFamily};
  font-size: ${props => props.theme.typography.button.fontSize};
  font-weight: ${props => props.theme.typography.button.fontWeight};
  letter-spacing: ${props => props.theme.typography.button.letterSpacing};
  text-transform: ${props => props.theme.typography.button.textTransform};
  
  background: transparent;
  color: ${props => props.theme.colors.primary.buttons};
  border: 1px solid ${props => props.theme.colors.primary.buttons};
  border-radius: 50px;
  
  padding: ${props => props.theme.spacing.md} ${props => props.theme.spacing.lg};
  cursor: pointer;
  transition: ${props => props.theme.transitions.default};
  text-decoration: none;
  position: relative;
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sm};
  
  &:hover {
    background: ${props => props.theme.colors.primary.buttons};
    color: ${props => props.theme.colors.primary.background};
    transform: translateY(-2px);
    
    svg {
      fill: ${props => props.theme.colors.primary.background};
    }
  }
  
  &:active {
    transform: translateY(0);
  }
  
  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    padding: ${props => props.theme.spacing.sm} ${props => props.theme.spacing.md};
    font-size: 0.85rem;
  }
`;

const StyledCartIcon = styled(CartIcon)`
  width: 24px;
  height: 24px;
  fill: ${props => props.theme.colors.primary.buttons};
  transition: ${props => props.theme.transitions.default};
  
  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    width: 20px;
    height: 20px;
  }
`;

const CartBadge = styled.span`
  position: absolute;
  top: -8px;
  right: -8px;
  background: ${props => props.theme.colors.accent.main};
  color: ${props => props.theme.colors.primary.background};
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  font-weight: 700;
  font-family: ${props => props.theme.typography.primary.fontFamily};
`;

const CartButton = ({ onClick }) => {
  const { getCartItemCount } = useCart();
  const itemCount = getCartItemCount();

  return (
    <CartButtonContainer onClick={onClick}>
      <StyledCartIcon />
      {itemCount > 0 && (
        <CartBadge>{itemCount}</CartBadge>
      )}
    </CartButtonContainer>
  );
};

export default CartButton;